import {
  resolveDataRuntimeConfig as resolveRuntimeConfig,
  type DataRuntimeConfig,
  type RuntimeEnvironment,
} from "@huyafed/gametool-data-runtime";

export type { DataRuntimeConfig };

export function resolveDataRuntimeConfig(env: RuntimeEnvironment): DataRuntimeConfig {
  const config = resolveRuntimeConfig(env);

  if (config.source === "remote") return config;

  return {
    ...config,
    versionRoot: `${config.versionRoot}/converted`,
  };
}

export function getDataRuntimeConfig(): DataRuntimeConfig {
  return resolveDataRuntimeConfig(__DATA_RUNTIME_ENV__);
}
